export default function Page404() {
  return <h1>Page404 - Content not found.</h1>;
}
